import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Steps extends Component {

    render() {
        return (
            <div className="row form-steps">
                {this.props.step_array.map((item,i) => {
                    if (item.link && this.props.step !== (i+1)) {
                        return (
                            <div key={i} className={"" + (this.props.step === (i+1) ? 'active' : 'inactive')}>
                            <NavLink to={item.link}>
                                {i+1}. {item.step_name}
                            </NavLink>
                            </div>
                        );
                    } else {
                        return (
                        <div key={i} className={"" + (this.props.step === (i+1) ? 'active' : 'inactive')}>
                            <span>{i+1}. {item.step_name}</span>
                        </div>
                        );
                    }   
                })}            

                {/*
                <div className={"" + (this.props.step === 1 ? 'active' : '')}>
                    1. Description</div>
                <div className={"" + (this.props.step === 2 ? 'active' : '')}>
                   2. Venue</div>
                <div className={"" + (this.props.step === 3 ? 'active' : '')}>
                    3. Presenters</div>
                */}
            </div>
        );
    }
}

export default Steps;
